@if (!editing) {
  <div
    role="button"
    tabindex="0"
    class="group-edit-handler"
    [textContent]="name"
    (click)="startEditing()"
    (keydown.enter)="startEditing()"
    (keydown.space)="startEditing()">
  </div>
}
@if (editing) {
  <input
    #nameInput
    class="group-edit-in-place--input"
    type="text"
    opAutofocus
    [(ngModel)]="editedName"
    [attr.placeholder]="placeholder"
    (blur)="saveEdition($event)"
    (keydown.escape)="reset()"
    (keydown.enter)="saveEdition($event)">
}
